import { StatusPill } from '../ui/StatusPill';

/**
 * EV-20: certification, custody and open exceptions are three separate facts.
 * Rendered side by side so no one reads "certified" as "in custody" or
 * "in custody" as "no exceptions".
 */
export function CustodyFactsPills({ record, className = '' }) {
  if (!record) return null;
  const certification =
    record.certification_status ||
    (record.package_status === 'CERTIFIED' ? 'CERTIFIED' : 'NOT_CERTIFIED');
  const custody = record.custody_status || record.custody_state || 'PENDING';
  const openExceptions = Number.isFinite(Number(record.open_exceptions))
    ? Number(record.open_exceptions)
    : null;

  return (
    <div
      className={`flex flex-wrap items-center gap-2 ${className}`}
      role="group"
      aria-label="Custody facts"
    >
      <StatusPill
        value={certification}
        label={certification === 'CERTIFIED' ? 'Certified' : 'Not certified'}
      />
      <StatusPill
        value={custody}
        label={custody === 'ACCEPTED' ? 'In custody' : `Custody ${String(custody).toLowerCase()}`}
      />
      {openExceptions != null ? (
        <StatusPill
          value={openExceptions > 0 ? 'OPEN' : 'CURED'}
          label={
            openExceptions > 0
              ? `${openExceptions} open exception${openExceptions === 1 ? '' : 's'}`
              : 'No open exceptions'
          }
        />
      ) : null}
    </div>
  );
}

export function mandateSummaryLabel(mandate) {
  if (!mandate) return null;
  const parts = [mandate.principal, mandate.capacity ? `as ${mandate.capacity}` : null].filter(
    Boolean
  );
  const head = parts.join(' ');
  return mandate.mandate_reference ? `${head} · ${mandate.mandate_reference}` : head;
}
